import { showSnackbarAction, hideSnackbarAction } from 'actions/snackbar';
import { useDispatch } from 'react-redux';

export const SNACKBAR_SEVERITIES = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

export const SNACKBAR_POSITIONS = {
  topLeft: 'topLeft',
  topCenter: 'topCenter',
  topRight: 'topRight',
  bottomRight: 'bottomRight',
  bottomCenter: 'bottomCenter',
  bottomLeft: 'bottomLeft',
};

function convertPositionToVerticalHorizontal(position = '') {
  switch (position) {
    case SNACKBAR_POSITIONS.topLeft:
      return { vertical: 'top', horizontal: 'left' };
    case SNACKBAR_POSITIONS.topCenter:
      return { vertical: 'top', horizontal: 'center' };
    case SNACKBAR_POSITIONS.bottomCenter:
      return { vertical: 'bottom', horizontal: 'center' };
    default:
      return { vertical: 'bottom', horizontal: 'center' };
  }
}

export function useSnackbar() {
  const dispatch = useDispatch();
  function showSnackbar(severity = SNACKBAR_SEVERITIES.success) {
    return ({ message, position = SNACKBAR_POSITIONS.bottomCenter, timeout = 2000 }) => {
      const { vertical, horizontal } = convertPositionToVerticalHorizontal(position);
      dispatch(showSnackbarAction({ severity, message, vertical, horizontal }));
      hideSnackbar(timeout);
    };
  }
  const showSuccessSnackbar = showSnackbar(SNACKBAR_SEVERITIES.success);
  const showErrorSnackbar = showSnackbar(SNACKBAR_SEVERITIES.error);
  const showWarningSnackbar = showSnackbar(SNACKBAR_SEVERITIES.warning);
  const showInfoSnackbar = showSnackbar(SNACKBAR_SEVERITIES.info);

  function hideSnackbar(timeout = 2000) {
    setTimeout(() => {
      dispatch(hideSnackbarAction());
    }, timeout);
  }
  return {
    showSuccessSnackbar,
    showErrorSnackbar,
    showWarningSnackbar,
    showInfoSnackbar,
    hideSnackbar,
  };
}
